// src/components/WhatsAppFloatingButton.jsx

import React from "react";
import { MessageCircle } from "lucide-react";

import "./WhatsAppFloatingButton.css";


const WhatsAppFloatingButton = () => {

  const handleWhatsApp = () => {

    const message =
      "Hello Bairagi Consultants, I would like to discuss a software requirement.";

    const url =
       `https://wa.me/919433510469?text=${encodeURIComponent(
        message
      )}`;

    window.open(
      url,
      "_blank",
      "noopener,noreferrer"
    );
  };


  return (
    <button
      type="button"
      className="floating-whatsapp"
      onClick={handleWhatsApp}
      aria-label="Contact Bairagi Consultants on WhatsApp"
    >

      <span className="floating-whatsapp-label">
        Need Help?
      </span>

      <span className="floating-whatsapp-icon">
        <MessageCircle size={25} />
      </span>

    </button>
  );
};


export default WhatsAppFloatingButton;